












import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import ScientficProjectDetailInfo from './scientficProjectDetailInfo.vue'
import FinalAcceptance from './finalAcceptance.vue'
@Component({
    name:'scientficProjectDetail',
    components: {
        ScientficProjectDetailInfo,
        FinalAcceptance
    }
})
export default class ScientficProjectDetail extends AbpBase  {
    initData:any = {
        projectName: null,
        currentName: 'scientficProjectDetailInfo'
    }
    //切换详情内容
    SwitchProjectDetail(name:any){
        this.initData.currentName = name;
    }
    //设置项目名称
    SetName(name:any) {
        this.initData.projectName = name;
    }
    async mounted() {
        
    }
}
